// src/plugins/vuetify.js

import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#009a44',
        secondary: '#b0bec5',
      },
      dark: {
        primary: '#005927',
        secondary: '#b0bec5',
        background: '#0D1A15'
      },
    },
    options: {
      customProperties: true,
    },
  },
})

export default vuetify